// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2fkmu","infoBtn":"quickbooks_infoBtn__2LHJ7","formBox":"quickbooks_formBox__3d6Nw","formFooter":"quickbooks_formFooter__oHHek"};